'use client';
import { CheckVerified01, Folder } from '@ethsign/icons';
import { Badge } from '@ethsign/ui';

import { ReactNode } from 'react';

import { TemplatePreviewModal } from '@/components/TemplatePreview';
import { useRouter } from '@/hooks';
import { ITemplate } from '@/types';

type Props = {
  data: ITemplate;
  footer?: ReactNode;
  action?: ReactNode;
  service?: (id: string) => Promise<any>;
};

const tagsColor: any = {
  Fundraising: 'text-blue-700 bg-blue-50',
  Employment: 'text-primary-700 bg-primary-50',
  'Business Transaction': 'text-cyan-700 bg-cyan-50',
  'Intellectual Property': 'text-secondary-700 bg-secondary-50',
  'Entity Mapping ': 'text-darkMatter-700 bg-darkMatter-50',
  'Entity Setup': 'text-teal-700 bg-teal-50',
  'Business Operations': 'text-darkMatter-700 bg-darkMatter-50',
  'Company Administration': 'text-teal-700 bg-teal-50'
};

export function ContractTemplateCard({ data, footer, action, service }: Props) {
  const { name: title, status, coverPicture: img, categoryName: type } = data;
  const router = useRouter();
  return (
    <>
      <div className="relative border border-gray-200 rounded-lg overflow-hidden">
        <div className="relative cursor-pointer w-full h-[200px] overflow-hidden">
          <TemplatePreviewModal
            service={service}
            handleUse={(data) => {
              router.push(`/prepare/temp${Date.now()}?templateId=${data?.id}`);
              console.log('use', data);
            }}
            trigger={<div>{img && <img className="w-full h-[200px] object-cover" alt="" src={img}></img>}</div>}
            data={data}
            key={data.id}
          />
          {action}
          {data?.collectionName ? (
            <Badge className={'rounded-sm bg-tangerine-50 text-tangerine-500 absolute left-2 bottom-2'}>
              <span className={'inline-block mr-1.5'}>
                <Folder color={'#EF6820'} size={20} />
              </span>
              {data?.collectionName}
            </Badge>
          ) : null}
        </div>
        <div className="w-full p-4">
          <div className="text-md font-medium text-gray-900 flex flex-row justify-between items-center">
            <div className="flex items-center">
              <span className="line-clamp-1" title={title}>
                {title}
              </span>
              {status === 'verified' && (
                <span className="ml-1">
                  <CheckVerified01 size={16} color="#EF6820"></CheckVerified01>
                </span>
              )}
            </div>
          </div>
          {type && (
            <span
              className={`text-xs font-medium rounded px-[6px] py-[2px] text-blue-700 bg-blue-50 ${tagsColor[type]}`}
            >
              {type}
            </span>
          )}
          {/*<div className="text-xs font-normal text-gray-700 w-full line-clamp-2 min-h-[36px]" title={desc}>*/}
          {/*  {desc}*/}
          {/*</div>*/}
          {/*<div className="mt-4 text-xs font-normal text-gray-400">*/}
          {/*  Created by:*/}
          {/*  <a href={''} target="_blank" rel="noreferrer">*/}
          {/*    <span className="font-medium text-gray-600"> {providerName}</span>*/}
          {/*  </a>*/}
          {/*</div>*/}
          {footer}
        </div>
      </div>
    </>
  );
}
